/* Cazameeza Winter PDP — quantity refresh bridge only. */
(function () {
  'use strict';

  function wakeAov(button) {
    var form = button && button.closest ? button.closest('form.t4s-form__product') : null;
    if (!form || !form.closest('.t4s-section-main-product')) return;

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        var input = form.querySelector('.t4s-product-form__qty [data-quantity-value], input[name="quantity"]');
        if (!input) return;

        input.dispatchEvent(new Event('input', { bubbles: true }));

        if (typeof form._cazaAovRender === 'function') {
          form._cazaAovRender();
        }
      });
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest
      ? event.target.closest('.t4s-section-main-product [data-quantity-selector]')
      : null;

    if (!button) return;
    wakeAov(button);
  });
})();
